import {
  action,
  observable,
} from 'mobx';
import {
  convertCountriesToISOCodeString,
} from '../../constants/countries';
import {
  DefaultLanguage,
} from '../../constants/languages';
import {
  getHeader,
} from '../../helperFunctions/getHeader';
import {
  ICountry,
} from '../storeInterfaces/authInterface';
import {
  IFacilityFormStore,
  FacilityFormStoreModel,
  FacilityFormFormModel,
  QuestionType,
} from '../storeInterfaces/facilityFormInterface';
import {
  getfacilityForms,
  createFacilityForm,
  getFacilityFormById,
  updateFacilityForm,
  getUserFormResponse,
} from '../../axios/facilityFormRequests';
import Connections from '../../connections';
import { RequestStatus } from 'mobx-store';
import { FacilityDTO } from 'screens/addEditFacilityForm/facilityDTO';

export class FacilityFormStore implements IFacilityFormStore {
  @observable facilityForms: Partial<FacilityFormStoreModel>[] = [];

  @observable selectedFacilityForm: any;

  @observable loading = false;

  @observable loadingState: RequestStatus = RequestStatus.IDLE;

  @observable addEditLoadingState: RequestStatus = RequestStatus.IDLE;

  @observable userFormResponse: any;

  @observable otherFacilityQuestions = [];

  @observable getFacilitiesFormsRequestStatus: RequestStatus = RequestStatus.IDLE;

  @action
  public async getAll(countries: ICountry[], langCode: string = DefaultLanguage): Promise<void> {
    try {
      this.loading = true;
      this.getFacilitiesFormsRequestStatus = RequestStatus.LOADING;
      const availableCountries = convertCountriesToISOCodeString(countries);

      const params = {
        availableCountries,
      };

      const config = {
        ...getHeader(langCode),
        params,
      };

      const response = await Connections.wadiDeglaAxios.httpGet(getfacilityForms, config);
      this.facilityForms = response.data;
      this.getFacilitiesFormsRequestStatus = RequestStatus.SUCCESS;

    } catch (error) {
      this.getFacilitiesFormsRequestStatus = RequestStatus.FAILED;
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async getOne(id: number, langCode: string = DefaultLanguage): Promise<void> {
    try {
      this.loadingState = RequestStatus.LOADING;

      const response = await Connections.wadiDeglaAxios.httpGet(getFacilityFormById(id), getHeader(langCode)); 
      this.selectedFacilityForm = {
        ...response.data,
        questions: response.data.questions
          .filter((fq: any) => fq.type === QuestionType.MCQ),
      };
      this.otherFacilityQuestions = response.data.questions
        .filter((fq: any) => fq.type !== QuestionType.MCQ)
        .map((q: any) => {
          q.options = q.questionOptions;
          delete q.questionOptions;
          return q;
        });
        this.loadingState = RequestStatus.SUCCESS;
    } catch (error) {
      this.loadingState = RequestStatus.FAILED;
      console.log(error);
    }
  }

  @action.bound
  public async create(newFacilityForm: FacilityDTO, langCode: string = DefaultLanguage): Promise<number> {
    return new Promise<number>(async (res, rej) => {
      try {
        console.log('in store ===>', newFacilityForm);
        this.loadingState = RequestStatus.LOADING;
        const response = await Connections.wadiDeglaAxios.httpPost(createFacilityForm, newFacilityForm, getHeader(langCode));
        res(response.data);
        this.loadingState = RequestStatus.SUCCESS;
      } catch (error) {
        this.loadingState = RequestStatus.FAILED;
        rej(error);
      }
    });
  }

  @action.bound
  public async update(updatedFacilityForm: FacilityDTO, FacilityFormId: number, langCode: string = DefaultLanguage): Promise<void> {
    return new Promise<void>(async (res, rej) => {
      try {
        updatedFacilityForm.questions = updatedFacilityForm.questions.map((q: any) => {
          if (!q?.sharedQuestionsFormContentId) {
            q.shared = true;
          }
          return q;
        });
        console.log('in store ===>', updatedFacilityForm);
        updatedFacilityForm.questions = [
          ...updatedFacilityForm.questions, ...this.otherFacilityQuestions
        ];
        this.addEditLoadingState = RequestStatus.LOADING;
        await Connections.wadiDeglaAxios.httpPut(updateFacilityForm(FacilityFormId), updatedFacilityForm, getHeader(langCode));
        this.addEditLoadingState = RequestStatus.SUCCESS;
        res();
      } catch (error) {
        this.addEditLoadingState = RequestStatus.FAILED;
        rej(error);
      }
    });
  }

  @action.bound
  public async getUserFormResponse(userFormResponseId: number, langCode: string = DefaultLanguage): Promise<void> {
    return new Promise<void>(async (res, rej) => {
      try {
        langCode = "en";
        const response = await Connections.wadiDeglaAxios.httpGet(getUserFormResponse(userFormResponseId), getHeader(langCode));
        this.userFormResponse = response.data;
        res();
      } catch (error) {
        rej(error);
      }
    });
  }

}
